var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounShoppingCart757319(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-952.36218)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      textIndent: 0,
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      baselineShift: "baseline",
      color: "#000000",
      enableBackground: "accumulate"
    },
    d: "m 10,964.36225 c -1.1046,0 -2,0.89543 -2,2 0,1.10457 0.8954,2 2,2 l 10.375,0 10.5312,49.74995 c 0.2555,1.2291 1.0765,2.263 2.0938,2.25 l 50,0 c 1.0566,0.015 2.0285,-0.9432 2.0285,-2 0,-1.0567 -0.9719,-2.0149 -2.0285,-2 l -48.375,0 -10.6562,-50.43745 C 23.7706,965.04077 22.9059,964.35452 22,964.36225 z m 20,12.00001 2.5938,13 16.4062,0 0,-13 z m 23,0 0,13 16,0 0,-13 z m 20,0 0,13 15.9688,0 3.0312,-13 z m -39.5938,17 2.5938,13.00004 13,0 0,-13.00004 z m 19.5938,0 0,13.00004 16,0 0,-13.00004 z m 20,0 0,13.00004 12,0 3.0312,-13.00004 z m -29,32.99994 c -3.8659,0 -7,3.134 -7,7 0,3.866 3.1341,7 7,7 3.866,0 7,-3.134 7,-7 0,-3.866 -3.134,-7 -7,-7 z m 28,0 c -3.8659,0 -7,3.134 -7,7 0,3.866 3.1341,7 7,7 3.866,0 7,-3.134 7,-7 0,-3.866 -3.134,-7 -7,-7 z",
    fillOpacity: 1,
    stroke: "none",
    visibility: "visible",
    display: "inline"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounShoppingCart757319);
export default __webpack_public_path__ + "static/media/noun_Shopping_Cart_757319.606b2213a74ddd916dbdafb1ca6ba10c.svg";
export { ForwardRef as ReactComponent };